function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "snow-flake--winter-freeze-snow-freezing-ice-cold-weather-snowflake"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m16.786 1.679 6.714 6.714 6.714 -6.714",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m1.679 30.214 6.714 -6.714 -6.714 -6.714",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m30.214 45.321 -6.714 -6.714 -6.714 6.714",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m45.321 16.786 -6.714 6.714 6.714 6.714",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.75 11.75 16.786 16.786",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m16.786 30.214 -5.036 5.036",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M35.25 11.75 30.214 16.786",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m30.214 30.214 5.036 5.036",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.5 8.393v30.214",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.393 23.5h30.214",
  strokeWidth: 3
}));

function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.a5f1ac8d.svg";
export { ForwardRef as ReactComponent };